import React, { PropsWithChildren, ReactNode } from 'react';
import { Collapse as AntCollapse } from 'antd';
import { SCollapse, SPanel } from './Collapse.styled';

export const Collapse = ({
  children,
  position = 'start',
  iconActive,
  iconInactive,
  noBorder,
  noMargin,
  defaultActiveKey = ['1'],
  noShadow,
  onChange,
  width,
}: PropsWithChildren<{
  position?: 'start' | 'end';
  iconActive?: ReactNode;
  iconInactive?: ReactNode;
  noBorder?: boolean;
  noMargin?: boolean;
  defaultActiveKey?: string[] | string | number[] | number;
  noShadow?: boolean;
  onChange?: (key: string | string[]) => void;
  width?: number;
}>) => {
  return (
    <SCollapse
      defaultActiveKey={defaultActiveKey}
      expandIconPosition={position}
      expandIcon={iconActive && iconInactive ? ({ isActive }) => (isActive ? iconActive : iconInactive) : undefined}
      noBorder={noBorder}
      noMargin={noMargin}
      noShadow={noShadow}
      onChange={onChange}
      width={width}
    >
      {children}
    </SCollapse>
  );
};

export const SectionCollapse = ({
  children,
  position,
  defaultActiveKey,
  noShadow,
  width,
}: PropsWithChildren<{
  position?: 'start' | 'end';
  defaultActiveKey?: string[] | string | number[] | number;
  noShadow?: boolean;
  width?: number;
}>) => {
  return (
    <Collapse
      defaultActiveKey={defaultActiveKey}
      position={position ?? 'start'}
      noBorder
      noShadow={noShadow}
      noMargin
      width={width}
    >
      {children}
    </Collapse>
  );
};

interface AccordionProps {
  children: ReactNode;
  onChange?: (key: string | string[]) => void;
  activeKey?: string;
}

export const Accordion = ({ children, onChange, activeKey }: AccordionProps) => {
  return (
    <AntCollapse onChange={onChange} accordion defaultActiveKey={['1']} activeKey={activeKey}>
      {children}
    </AntCollapse>
  );
};

export const CollapseWithKey = ({
  children,
  position = 'start',
  iconActive,
  iconInactive,
  noBorder,
  noMargin,
  noShadow,
  onChange,
  activeKey,
}: PropsWithChildren<{
  position?: 'start' | 'end';
  iconActive?: ReactNode;
  iconInactive?: ReactNode;
  noBorder?: boolean;
  noMargin?: boolean;
  noShadow?: boolean;
  onChange?: (key: string | string[]) => void;
  activeKey?: Array<string | number> | string | number;
}>) => {
  return (
    <SCollapse
      expandIconPosition={position}
      expandIcon={iconActive && iconInactive ? ({ isActive }) => (isActive ? iconActive : iconInactive) : undefined}
      noBorder={noBorder}
      noMargin={noMargin}
      noShadow={noShadow}
      onChange={onChange}
      activeKey={activeKey}
    >
      {children}
    </SCollapse>
  );
};

export const Panel = SPanel;
